# This is a wrapper for the Journal service.
# Example Usage:
# logger.log('Data Warehouse Usage', 'Open', 1, 'edit')
angular.module('rjmNg.services').factory 'logger', [
  "Journal"
  "app"
  (Journal, app) ->
    # Logs an event to the journal
    log : (type, key, value, action, perspective) ->
      Journal.save
        type: type
        key: key # Open | Save | Delete
        value: value
        meta:
          clientId: app.getClientId()
          userId: app.getUserId()
          isSupportUser: app.isSupportUserSession()
          action: action # create | edit
          perspective: perspective

  ]
